module.exports = __webpack_public_path__ + "static/media/exchange.9e34740d.svg";